/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class LunchCountsApi {
  async LoadLunchOrders(AGU : string) : Promise<pxp.GetLunchOrderInfoResponse> {
    return await componentApi.call('pxp', 'pxp-lunch-counts', 'LunchCountsApi', 'LoadLunchOrders', {
      AGU,
    });
  }
  async UpdateLunchOrder(StudentLunchOrder : pxp.StudentLunchOrder, AGU : string) : Promise<pxp.UpdateLunchOrderInfoResponse> {
    return await componentApi.call('pxp', 'pxp-lunch-counts', 'LunchCountsApi', 'UpdateLunchOrder', {
      StudentLunchOrder,
      AGU,
    });
  }
}
export default new LunchCountsApi()
